/**
 * External dependencies.
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Internal dependencies.
 */
import ReactHubspotForm from '../../react-hubspot-form';
import { sanitize } from '../../../utils/functions';

import './style.scss';

/**
 * Conversation Advert Form Component.
 *
 * @param {Object} meta Component props.
 *
 * @return {jsx}
 */
const ConversationAdvertForm = ({ meta, tagParent, tagName }) => {

	const { headline, formPortalid, formId, formContent } = meta;

	if (!formId) {
		return null;
	}

	return (
		<section className="advertiser-sections conversation-form" id="contact-us">
			<div className="row align-right">
				<div className="large-8 medium-12 small-12 columns conversation-form__heading-wrap">
					<h2 className="conversation-form__heading" dangerouslySetInnerHTML={{ __html: sanitize(headline) }} />
					{
						formContent && (
							<div className="conversation-form__text-content" dangerouslySetInnerHTML={{ __html: sanitize(formContent) }} />
						)
					}
				</div>
				<div className="large-4 medium-6 small-12 columns">
					<div className="conversation-form__form">
						<ReactHubspotForm
							portalId={formPortalid}
							formId={formId}
							tagName={tagName}
							tagParent={tagParent}
							formAction="formAction"
						/>
					</div>
				</div>
			</div>
		</section>
	);

};

ConversationAdvertForm.propTypes = {
	meta: PropTypes.object,
	tagParent: PropTypes.string,
	tagName: PropTypes.string,
};

ConversationAdvertForm.defaultProps = {
	meta: {
		headline: '',
		formPortalid: '',
		formId: ''
	},
	tagParent: '',
	tagName: '',
}

export default ConversationAdvertForm;
